<template lang="html">
	<div id="page__prices" class="center-panel">
		<md-content class="md-elevation-1" md-theme="white" v-loader-overlay="progress">
			<PricesMenu></PricesMenu>
			<sort-table 
				v-bind:columns="tableColumns" v-model="prices" @refresh="getPrices" v-bind:per-page="perPage" 
				v-bind:total="pricesAmount" link table-id="prices" ref="table" v-on:create="addPrice" tableHeight="calc(100% - 48px)"
			>
				<template slot="from" slot-scope="scope">
					<span no-breack-words> {{ scope.item.zone_id_from ? scope.item.zone_from.name + ' (направление)' : scope.item.city_from.name + ' (город)' }}</span>
				</template>
				<template slot="to" slot-scope="scope">
					<span no-breack-words> {{ scope.item.zone_id_to ? scope.item.zone_to.name + ' (направление)' : scope.item.city_to.name + ' (город)' }}</span>
				</template>
				<template slot="type" slot-scope="scope"> {{ parseInt(scope.item.type) == 2 ? 'По объёму' : 'По весу' }}</template>

				<template slot="is_min" slot-scope="scope"> {{ parseInt(scope.item.is_min) == 1 ? 'Да' : 'Нет' }}</template>
				<template slot="actions" slot-scope="scope">
					<z-icon-button v-bind:icon="['fa', 'clone']" v-on:click.stop.prevent="clone(scope.item.id)" rounded></z-icon-button>
					<z-icon-button v-bind:icon="['fa', 'trash']" v-on:click.stop.prevent="onRemove(scope.item.id)" danger-light rounded></z-icon-button>
				</template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import PricesMenu from './PricesMenu.vue';
	import SortTable from '@/components/SortTable';
	import ZIconButton from '@/components/ZIconButton.vue';
	export default {
		components: { SortTable, PricesMenu, ZIconButton },
		data() {
			return {
				perPage: 50,
				tableColumns: [
					{ label: 'ID', field: 'id', sortable: true },
					{ label: 'Пункт отправления', field: 'from' },
					{ label: 'Пункт назначения', field: 'to' },

					{ label: 'Тип расчёта', field: 'type' },
					{ label: 'Минимальный', field: 'is_min' },

					{ label: 'Вес мин.', field: 'weight_min' },
					{ label: 'Вес макс.', field: 'weight_max' },

					{ label: 'Объём мин.', field: 'volume_min' },
					{ label: 'Объём макс.', field: 'volume_max' },

					{ label: 'Цена за ед. веса', field: 'price_weight' },
					{ label: 'Цена за ед. объёма', field: 'price_volume' },

					{ label: 'Цена за мин. вес', field: 'price_weight_min' },
					{ label: 'Цена за мин. объём', field: 'price_volume_min' },

					{ label: '', field: 'actions' },
				],
			}
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-prices-list'];
			},
			/**
			 * Объект с флагами загразки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список цен
			 */
			prices() {
				return this.$store.state.cost.prices.map(price => {
					price.routerLink = { name: 'Price', params: { price_id: price.id }, query: this.$route.query };
					return price;
				});
			},
			/**
			 * Количество цен
			 */
			pricesAmount() {
				return this.$store.state.cost.prices_amount
			}
		},
		created() {
			this.$store.commit('setTitle', 'Цены')
		},
		methods: {
			/**
			 * Добавление цены
			 */
			addPrice() {
				this.$router.push({ name: 'Price', params: { price_id: 'new' } });
			},
			/**
			 * Получение цен
			 */
			getPrices(page, count, orderBy, orderType, filter) {
				this.$store.commit('showProgressBar', 'get-prices-list');
				this.$store.dispatch('cost/getPrices', {
					page: page, 
					order_by: orderBy, 
					order_type: orderType, 
					count: count, 
					filter: this.resolveQueryFilter()
				}).finally(() => this.$store.commit('hideProgressBar', 'get-prices-list'));
			},
			/**
			 * Клониерование цены с созданием новой
			 */
			clone(id) {
				let query = Object.assign({}, this.$route.query);
				if (query) query.clone_id = id;
				else query = {clone_id: id};

				this.$router.push({ name: 'Price', params: { price_id: 'new' }, query: query});
			},
			/**
			 * ФИльтрация
			 */
			resolveQueryFilter() {
				if (!this.$route.query || !this.$route.query.filter) return null;
				let filter = Object.assign({}, JSON.parse(this.$route.query.filter)), model = [], result = {model: [], relation: [], condition: 'and'};

				if (filter.type) model.push(['type', '=', filter.type]);
				if (filter.city_id_from) model.push(['city_id_from', '=', filter.city_id_from]);
				if (filter.city_id_to) model.push(['city_id_to', '=', filter.city_id_to]);
				if (filter.zone_id_from) model.push(['zone_id_from', '=', filter.zone_id_from]);
				if (filter.zone_id_to) model.push(['zone_id_to', '=', filter.zone_id_to]);

				model.map((item, i) => {
					result.model.push(item);
					if (model[i+1]) result.model.push('and');
				});
				return result
			},
			/**
			 * Удаление цены
			 */
			removePrice(id) {
				if (!id) return;
				this.$store.commit('showProgressBar', 'get-prices-list');
				this.$store.dispatch('cost/deletePrice', { id: id })
					.then(() => this.$root.$emit('refresh-table', 'prices'))
					.finally(() => this.$store.commit('hideProgressBar', 'get-prices-listt'));
			},
			/**
			 * Модальное окно с удалением цены
			 */
			onRemove(id) {
				this.$root.$emit(
					'z-alert', 'Вы уверены в удалении цену?', 'Действие необратимо!',
					() => this.removePrice(id)
				);
			}
		}
	}
</script>


// WEBPACK FOOTER //
// Prices.vue?33f0b16e